import moment from 'moment';
import BaseAccountController from '../../lib/controllers/BaseAccountController';

declare var LtFramework: lt.Static;

export interface IDateFilterOption {
	id: number;
	label: string;
	offset: number;
}

interface ITransactionEx extends MyAccountApi.ITransaction {
	date: Date; // JS Date representation of tranDate, used for sorting purposes
}

export default class TransactionHistoryController extends BaseAccountController {
	public static $inject: string[] = ['$window', '$scope', 'TransactionTypeResource', 'TransactionHistoryResource', 'UserResource'];

	public dateFilterOptions: IDateFilterOption[] = [];
	public typeFilterOptions: MyAccountApi.ITransactionType[] = [];
	public selectedDateFilter: IDateFilterOption;
	public selectedTypeFilter: MyAccountApi.ITransactionType;
	public allTransactions: MyAccountApi.ITransaction[] | null;
	public user: MyAccountApi.IUser;

	private readonly $window: ng.IWindowService;
	private readonly TransactionTypes: MyAccountApi.ITransactionTypeResource;
	private readonly Transactions: MyAccountApi.ITransactionHistoryResource;
	private readonly User: MyAccountApi.IUserResource;

	constructor($window: ng.IWindowService, $scope: ng.IScope, TranTypes: MyAccountApi.ITransactionTypeResource,
			Transactions: MyAccountApi.ITransactionHistoryResource, User: MyAccountApi.IUserResource) {
		super($scope);

		this.$window = $window;
		this.TransactionTypes = TranTypes;
		this.Transactions = Transactions;
		this.User = User;

		this.loadFilterData();
	}

	public filterChanged(): void {
		this.allTransactions = null;
		this.queryTransactions(this.selectedDateFilter.offset, this.selectedTypeFilter.description);
	}

	public print(): void {
		this.$window.print();
	}

	/**
	 * Triggered whenever SSO ID is available/changed
	 */
	protected loadData(): void {
		this.queryTransactions(0, 'All');
		// load My Account user details
		this.user = this.User.get();
	}

	/**
	 * Triggered whenever profile data is available/changed
	 */
	protected profileDataLoaded(): void {
		return;
	}

	private loadFilterData(): void {

		for (let i = 0; i <= 12; i++) {
			const lessor = i;
			const month = moment().subtract(lessor, 'month');

			this.dateFilterOptions.push({
				id: i,
				label: month.format('MMMM YYYY'),
				offset: lessor
			});
		}

		this.selectedDateFilter = this.dateFilterOptions[0];

		this.typeFilterOptions = this.TransactionTypes.query((options: MyAccountApi.ITransactionType[]) => {
			this.selectedTypeFilter = options[0];
		});
	}

	private queryTransactions(offset: number, type: string): void {
		this.Transactions.query({offset, type}, this.updateTransactions.bind(this));
	}

	private updateTransactions(transactionResult: MyAccountApi.ITransactionHistory): void {
		this.allTransactions = transactionResult.transactionList;

		// Populate a new 'date' field on every tran object containing a proper Date.
		// The service just returns a string representation of the date, which can't be used for sorting.
		this.allTransactions.forEach((t: MyAccountApi.ITransaction) => {
			(t as ITransactionEx).date = moment(t.tranDate, 'MMM D, YYYY').toDate();
		});
	}
}
